export default __webpack_public_path__ + "static/img-03-d2ec6c7094184503bff5428dea23e51c.jpg";